import { TWIDBStore } from "@app/stateCommon/idbSchema";
import {
  MappingFunction,
  TBlueAny,
  TBlueNum,
  TBlueObj,
  TBlueStr,
  TBlueTable,
} from "@app/types/insider";

import { mapperIvf } from "./mapperfn-invoice";

export function isTBlueTable<T>(object: any): object is TBlueTable<T> {
  return "primaryKey" in object;
}

export function isTBlueObj<T>(object: any): object is TBlueObj<T> {
  return (
    !("primaryKey" in object) &&
    "initialState" in object &&
    typeof object.initialState === "object" &&
    !Array.isArray(object.initialState)
  );
}

export function isTBlueStr(object: any): object is TBlueStr {
  return "initialState" in object && typeof object.initialState === "string";
}

export function isTBlueAny(object: any): object is TBlueAny {
  return "isblueany" in object && object.isblueany === true;
}

export function isTBlueNum(object: any): object is TBlueNum {
  // Hypothetical type guard if TBlueNum is defined with a numeric initialState
  return "initialState" in object && typeof object.initialState === "number";
}

// we cannot declare the functions we need in the object
// as the functions are reffering to the object/schema itself
// we declare here and export them

export const storeMapFns = new Map<keyof TWIDBStore, MappingFunction>([
  ["invoiceFiscal", mapperIvf],
]);

// export const isTBuleEmpty = (name: string) => {
//   const state =  window.fx.geteState();
//   console.log('state', state)
//   const table = state[name];
//   if (table) {
//     // it could be any of table, obj, str, num, any
//     if (isTBlueTable(table)) {
//       return Object.keys(table).length === 0;
//     } else if (isTBlueObj(table)) {
//       return Object.keys(table).length === 0;
//     } else if (isTBlueStr(table)) {
//       return table.initialState === '';
//     } else if (isTBlueAny(table)) {
//       return Boolean(table);
//     }
//     return false;
//   }
//   return false;

// }
